import useI18n from "@/hooks/useI18n";
import Dialog from "./Dialog";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
};

export default function GenericFailure({ title, subtitle, isOpen, onClose }: Props) {
  const { t } = useI18n();
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      buttons={{ confirm: { label: t("account.button.ok"), onClick: onClose } }}
      title={title || t("account.genericFailure.heading")}
      subtitle={subtitle || t("account.genericFailure.subtitle")}
    />
  );
}
